import React, { useEffect, useState } from "react";
import { Container, Grid, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { commonConstants } from "../../../_redux/_constants/common.constants";
import { ForgotUsername } from "../ForgotUsername/ForgotUsername";
import { PwResetEnterCardDetails } from "./views/ForgotPassword/PwResetEnterCardDetails";
import { ResetPassword } from "./views/ForgotPassword/ResetPassword";
import { ResetPasswordSuccess } from "./views/ForgotPassword/ResetPasswordSuccess";
import { authReducerInitiate } from "../../../_redux/_actions";
import Logo from "../../../styles/img/df-logo.png";
import { PwResetEnterAccountDetails } from "./views/ForgotPassword/PwResetEnterAccountDetails";

export const ForgotPasswordWrapper = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const actionDispatch = useDispatch();

  useEffect(() => {
    actionDispatch(authReducerInitiate());
  }, []);

  const forgotPasswordScreenType = useSelector(
    (state) => state.auth?.forgotPasswordScreenType,
  );

  return (
    <>
      <div className="df-logo-nav">
        <Container maxWidth="xl">
          <div className="df-logo-nav__content">
            <img src={Logo} />
          </div>
        </Container>
      </div>
      {(() => {
        switch (forgotPasswordScreenType) {
          case commonConstants.FORGOT_PASSWORD_TAB_LIST_SCREEN:
            return <ForgotUsername />;

          case commonConstants.FORGOT_PASSWORD_ACCOUNT_DETAILS_SCREEN:
            return <PwResetEnterAccountDetails />;

          case commonConstants.FORGOT_PASSWORD_RESET_PASSWORD:
            return <ResetPassword />;

          case commonConstants.FORGOT_PASSWORD_RESET_PASSWORD_SUCCESS_SCREEN:
            return <ResetPasswordSuccess />;
        }
      })()}
    </>
  );
};
